import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';
import getFilteredTimeFormatOptions from '../utils/getFilteredTimeFormatOptions';
var getNewTimeFormat = function () {
    var optionState = getRegionalOptions();
    var UserOptions = getUserConfiguration().UserOptions;
    var newTimeFormat = optionState.selectedTimeFormat || UserOptions.TimeFormat;
    if (getFilteredTimeFormatOptions().indexOf(newTimeFormat) === -1) {
        // The user changed locales to one that didn't support their previous time format, and didn't update the selection
        // Default to the first option compatible with their locale
        newTimeFormat = getFilteredTimeFormatOptions()[0];
    }
    return newTimeFormat;
};
export default getNewTimeFormat;
//# sourceMappingURL=getNewTimeFormat.js.map